import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/api";
import { VehicleCard } from "@/components/VehicleCard";
import { Filter, X } from "lucide-react";

const ParcoVeicoli = () => {
  const [params, setParams] = useSearchParams();
  const [vehicles, setVehicles] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openFilters, setOpenFilters] = useState(false);

  const [f, setF] = useState({
    marca: params.get("marca") || "",
    alimentazione: params.get("alimentazione") || "",
    cambio: params.get("cambio") || "",
    badge: params.get("badge") || "",
    colore: params.get("colore") || "",
    anno_min: params.get("anno_min") || "",
    anno_max: params.get("anno_max") || "",
    prezzo_min: params.get("prezzo_min") || "",
    prezzo_max: params.get("prezzo_max") || "",
    km_max: params.get("km_max") || "",
    q: params.get("q") || "",
  });

  const fetchData = async () => {
    setLoading(true);
    const query = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    const r = await api.get("/vehicles", { params: query });
    setVehicles(r.data);
    setLoading(false);
  };

  useEffect(() => {
    api.get("/vehicles/brands").then((r) => setBrands(r.data));
  }, []);
  useEffect(() => {
    fetchData();
    const query = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    setParams(query, { replace: true });
  }, [JSON.stringify(f)]); // eslint-disable-line

  const reset = () => setF({ marca: "", alimentazione: "", cambio: "", badge: "", colore: "", anno_min: "", anno_max: "", prezzo_min: "", prezzo_max: "", km_max: "", q: "" });

  const input = "w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-2 text-sm text-white focus:border-[#E1BC56] focus:outline-none";
  const Field = ({ label, children }) => (
    <div>
      <label className="block text-[10px] tracking-widest uppercase text-zinc-500 mb-1.5 font-display">{label}</label>
      {children}
    </div>
  );

  const Sidebar = (
    <aside className="bg-[#121214] border border-white/10 rounded-lg p-5 space-y-4">
      <div className="flex justify-between items-center mb-2">
        <div className="font-display text-sm font-bold tracking-widest text-white">FILTRI</div>
        <button onClick={reset} className="text-[10px] tracking-widest uppercase text-[#E1BC56] hover:text-[#F3E29F]" data-testid="filter-reset">RESET</button>
      </div>
      <Field label="Ricerca"><input className={input} value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Marca, modello…" data-testid="filter-q" /></Field>
      <Field label="Marca">
        <select className={input} value={f.marca} onChange={(e) => setF({ ...f, marca: e.target.value })} data-testid="filter-marca">
          <option value="">Tutte</option>
          {brands.map((b) => <option key={b}>{b}</option>)}
        </select>
      </Field>
      <Field label="Alimentazione">
        <select className={input} value={f.alimentazione} onChange={(e) => setF({ ...f, alimentazione: e.target.value })} data-testid="filter-alimentazione">
          <option value="">Tutte</option><option>Benzina</option><option>Diesel</option><option>Ibrida</option><option>Elettrica</option>
        </select>
      </Field>
      <Field label="Cambio">
        <select className={input} value={f.cambio} onChange={(e) => setF({ ...f, cambio: e.target.value })} data-testid="filter-cambio">
          <option value="">Tutti</option><option>Automatico</option><option>Manuale</option>
        </select>
      </Field>
      <Field label="Stato">
        <select className={input} value={f.badge} onChange={(e) => setF({ ...f, badge: e.target.value })} data-testid="filter-badge">
          <option value="">Tutti</option><option>Disponibile</option><option>In Arrivo</option><option>Venduta</option>
        </select>
      </Field>
      <Field label="Colore Esterno"><input className={input} value={f.colore} onChange={(e) => setF({ ...f, colore: e.target.value })} placeholder="es. Nero, Rosso" data-testid="filter-colore" /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Anno Min"><input type="number" className={input} value={f.anno_min} onChange={(e) => setF({ ...f, anno_min: e.target.value })} data-testid="filter-anno-min" /></Field>
        <Field label="Anno Max"><input type="number" className={input} value={f.anno_max} onChange={(e) => setF({ ...f, anno_max: e.target.value })} data-testid="filter-anno-max" /></Field>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Prezzo Min €"><input type="number" className={input} value={f.prezzo_min} onChange={(e) => setF({ ...f, prezzo_min: e.target.value })} data-testid="filter-prezzo-min" /></Field>
        <Field label="Prezzo Max €"><input type="number" className={input} value={f.prezzo_max} onChange={(e) => setF({ ...f, prezzo_max: e.target.value })} data-testid="filter-prezzo-max" /></Field>
      </div>
      <Field label="Km Max"><input type="number" className={input} value={f.km_max} onChange={(e) => setF({ ...f, km_max: e.target.value })} data-testid="filter-km-max" /></Field>
    </aside>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="mb-10">
        <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-2">CATALOGO COMPLETO</div>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white tracking-widest">PARCO VEICOLI</h1>
        <p className="text-zinc-400 mt-3">Sfoglia la nostra selezione premium. Ogni veicolo è controllato, garantito e pronto alla consegna.</p>
      </div>

      <button onClick={() => setOpenFilters(!openFilters)} className="lg:hidden cmc-btn-outline w-full py-3 rounded-sm mb-4 flex items-center justify-center gap-2" data-testid="filter-toggle">
        {openFilters ? <X className="w-4 h-4" /> : <Filter className="w-4 h-4" />} FILTRI
      </button>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className={`${openFilters ? "block" : "hidden"} lg:block lg:col-span-1`}>{Sidebar}</div>
        <div className="lg:col-span-3">
          <div className="flex justify-between items-center mb-5">
            <div className="text-sm text-zinc-400">
              <span className="text-white font-bold">{vehicles.length}</span> veicoli
            </div>
          </div>
          {loading ? (
            <div className="text-center py-20 text-zinc-500">Caricamento…</div>
          ) : vehicles.length === 0 ? (
            <div className="text-center py-20 text-zinc-500 border border-dashed border-white/10 rounded-lg">Nessun veicolo trovato con i filtri selezionati.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {vehicles.map((v) => <VehicleCard key={v.id} v={v} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParcoVeicoli;
